module.exports = __webpack_public_path__ + "img/23.13481408.jpg";